import sc from 'styled-components';
import React from 'react';
import { Icon } from 'antd';

const DeleteChecked = sc.div`     
background: transparent;
border: none;
textAlign: left;
display: flex;
flex-direction: row;
justify-content: flex-start;
text-transform: uppercase;
align-items: baseline;
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
                             
`;

const Inner = sc.div`
width: 46px;
display: flex;
flex-direction: row;
justify-content: center;
align-items: baseline;
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
`;

export default props => (
  <DeleteChecked
    {...props}
  >
    <Inner><Icon type="delete" /></Inner>
    Delete Checked
  </DeleteChecked>
);
